import axios from 'axios'
import { getTzOffset, setCookie } from '../utils'

const APP_DATA = {
  URI: window.uri,
  APPLICATION: window.application,
}

// Needed to set browser cookies via API
axios.defaults.withCredentials = true

export const apiInstance = axios.create({
  baseURL: `${APP_DATA.URI}`,
})

apiInstance.interceptors.request.use((config) => {
  config.headers['app'] = APP_DATA.APPLICATION
  config.headers['Accept'] = 'application/json'
  config.headers['Content-Type'] = 'application/json'
  config.headers['Access-Control-Allow-Credentials'] = 'true'
  config.headers['timezone'] = getTzOffset()
  config.headers['languagecode'] = 'en'

  return config
})

apiInstance.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    if (error?.response?.status === 401) {
      // Clear cookies on logout
      setCookie('central', '', 1)
      localStorage.removeItem('email')
      localStorage.removeItem('isLoggedIn')
      localStorage.removeItem('access')
      window.location = '/login'
    } else {
      return Promise.reject(error)
    }
  }
)
